export const FILTER_CATEGORIES_CONFIG = {
    prices: { mode: 'multi', controlType: 'checkbox', ordered: true },
    stars: { mode: 'multi', controlType: 'pills', layout: 'pills', ordered: true },
    ratings: { mode: 'single', controlType: 'radio', ordered: true },
    amenities: { mode: 'multi', controlType: 'pills', layout: 'pills' },
    types: { mode: 'multi', controlType: 'checkbox', layout: 'grid' },
    themes: { mode: 'multi', controlType: 'checkbox', layout: 'grid' },
    districts: { mode: 'multi', controlType: 'checkbox', layout: 'grid' },
    landmarks: { mode: 'multi', controlType: 'checkbox', layout: 'grid' },
    airports: { mode: 'multi', controlType: 'checkbox', layout: 'grid' },
    brands: { mode: 'multi', controlType: 'checkbox', layout: 'grid' },
};
